import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { useDeleteMember, useGetMembers } from '../../../members/members.queries';
import { useUsers } from '../context/users-context';
import { UsersDeleteDialog } from './users-delete-dialog';

export function UsersDialogs() {
  const { t } = useTranslation('settings');
  const { open, setOpen, currentRow } = useUsers();
  const { refetch } = useGetMembers();
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteMember = useDeleteMember(
    () => {
      toast.success(t('members.toasts.memberDeleted'));
      refetch();
    },
    () => {
      toast.error(t('members.toasts.memberDeleteFailed'));
    }
  );

  if (!currentRow) return null;

  const handleDelete = async (memberId: number) => {
    setIsDeleting(true);
    try {
      await deleteMember.mutateAsync(memberId);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <UsersDeleteDialog
        open={open === 'delete'}
        onOpenChange={(isOpen) => setOpen(isOpen ? 'delete' : null)}
        currentRow={currentRow}
        onDelete={handleDelete}
        isDeleting={isDeleting}
      />
      {/* Add other dialogs here (edit, invite, etc.) */}
    </>
  );
}
